import { Trans } from 'react-i18next'

import { MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { Tooltip } from '@makyoapp/makyo-ui'

const SHORTCUTS = [
  {
    key: ['⌘', 'Z'],
    label: 'Undo',
  },
  {
    key: ['⌘', 'Y'],
    label: 'Redo',
  },
  {
    key: ['⌘', '←'],
    label: 'Show/Hide Editor',
  },
  {
    key: ['⌘', '→'],
    label: 'Show/Hide Navigator',
  },
  {
    key: ['⌘', '↓'],
    label: 'Show/Hide Panels',
  },
  {
    key: ['⌘', '↑'],
    label: 'Show/Hide Toolbar',
  },
  {
    key: ['⌘', 'D'],
    label: 'Open Data Panel',
  },
  {
    key: ['⌘', 'E'],
    label: 'Open Design Panel',
  },
]

export function KeyboardShortcutsTip() {
  return (
    <div className='absolute top-2 right-2 z-1'>
      <Tooltip
        content={
          <div className='text-sm py-2'>
            <div className='text-m-m mb-2'>
              <Trans>Keyboard Shortcuts</Trans>:
            </div>

            <div className='flex flex-col gap-2'>
              {SHORTCUTS.map((s) => (
                <div key={s.label} className='flex items-center gap-2.5'>
                  <div className='flex items-center gap-1'>
                    {s.key.map((k) => (
                      <div
                        key={k}
                        className='py-1 px-2 bg-zinc-600 text-zinc-50 dark:bg-slate-300 dark:text-slate-800 rounded-xs w-6 h-6 flex items-center justify-center'
                      >
                        {k}
                      </div>
                    ))}
                  </div>

                  <div className='text-m-m'>
                    <Trans>{s.label}</Trans>
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      >
        <div
          role='button'
          className='p-2 w-9 h-9 flex-cc aspect-square bg-zinc-300 text-zinc-800 dark:bg-slate-300  dark:text-slate-600 opacity-70 hover:opacity-100 rounded-md'
        >
          <MaterialIcon icon='keyboard_command_key' size={20} />
        </div>
      </Tooltip>
    </div>
  )
}
